import React, { useState, useEffect } from 'react';
import { Route, Redirect, Switch } from 'react-router-dom';
import { useSnackbar } from 'notistack';
import auth from './auth/authService';
import cas from './auth/casService';
import Dependencies from './Components/dependency/dependencies';
import DependencyForm from './Components/dependency/dependencyForm';
import EditActivityForm from './Components/project/components/activities/editActivityForm';
import EditRequirementForm from './Components/project/components/requirements/editRequirementForm';
import Groups from './Components/group/groups';
import GroupForm from './Components/group/groupForm';
import GroupMembersForm from './Components/group/member/groupMembersForm';
import Logout from './Components/logout';
import LoginScreen from './login/LoginScreen';
import Loading from './Components/common/loading';
import Members from './Components/project/member/members';
import MeProfile from './Components/user/profile/meProfile';
import Monthly from './Components/reports/monthly';
import NavBar from './Components/navBar';
import NotAuthorized from './Components/error/notAuthorized';
import NotFound from './Components/error/notFound';
import Pemissions from './Components/permission/permissions';
import PemissionForm from './Components/permission/permissionForm';
import Projects from './Components/project/projects';
import ProjectMain from './Components/project/projectMain';
import Query from './Components/reports/query';
import ResearcherForm from './Components/researcher/researcherForm';
import Researchers from './Components/researcher/researchers';
import Roles from './Components/role/roles';
import RoleForm from './Components/role/roleForm';
import Users from './Components/user/users';
import UserAddForm from './Components/user/userAddForm';
import UserUpdateForm from './Components/user/userUpdateForm';
import Welcome from './Components/welcome';

import './App.scss';
import ProjectsI from './Components/project/projectsI';
import projectMainInv from './Components/project/projectMainInv';
import GroupsI from './Components/group/groupsI';
import groupFormI from './Components/group/groupFormI';
import resolutionMain from './Components/project/resolutionMain';
import DropzoneMain from './Components/project/dropzoneMain';
import informeMain from './Components/project/informeMain';
import dropzoneMainInforme1 from './Components/project/dropzoneMainInforme1';
import dropzoneMainInforme2 from './Components/project/dropzoneMainInforme2';
import informe2Main from './Components/project/informe2Main';
import ReporteEstado from './Components/project/reports/reporteEstado';
import ReporteCobertura from './Components/project/reports/reporteCobertura';
import ReporteMultidisciplinario from './Components/project/reports/reporteMultidisciplinario';
import ReporteGeneroInvestigadores from './Components/project/reports/reporteGeneroInvestigadores';
import ReporteEstudiantes from './Components/project/reports/reporteEstudiantes';
import ReporteProgramas from './Components/project/reports/reporteProgramas';
import ReporteLineas from './Components/project/reports/reporteLineas';
import Lines from './Components/line/lines';
import LineForm from './Components/line/lineForm';
import LineAddForm  from './Components/line/lineAddForm'; 
import ProgramAddForm from './Components/line/programAddForm';  
import ProgramForm from './Components/line/programForm';


const App = () => {
  const [emailCas, setEmailCas] = useState(cas.getLogin());
  const [user, setUser] = useState(auth.getCurrentUser());
  const [roles, setRoles] = useState([]);
  const [selectedRole, setSelectedRole] = useState('');
  // eslint-disable-next-line no-unused-vars
  const [keyLostConection, setKeyLostConection] = useState('');
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    tryLogin();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const tryLogin = async () => {
    try {
      setIsLoading(true);
      if (!emailCas) {
        cas.saveTicket();
        await cas.getTicketCAS();
      }
      if (cas.isAuthenticated() && cas.getLogin() && !auth.isAuthenticated()) {
        const user = await auth.login(cas.getLogin());
        setUser(user);
        setEmailCas(cas.getLogin());
      }

      if (auth.getCurrentUser()) {
        const user = auth.getCurrentUser();
        getRolesByUser(user);
      }

      const key = detectedOffline();
      detectedOnLine(key);
    } catch (ex) {
      //console.log(ex);
      enqueueSnackbar(`Se produjo un error. ${ex}`, {
        variant: 'error',
      });
    } finally {
      setIsLoading(false);
    }
  };

  const getRolesByUser = (user) => {
    const { roles } = user;
    const selectedRol = auth.getSelectedRole();
    //console.log(selectedRol);
    setRoles(roles);
    setSelectedRole(selectedRol);
  };
  const handleLogin = () => {
    try {
      cas.redirect();
    } catch (err) {
      if (err.error !== 'login_required') console.log('error: ' + err);
    }
  };
  const handleLogout = () => {
    auth.logout();
    cas.logout();
  };

  const handleChangeRole = (roleId, closeFunction) => {
    closeFunction();
    const role = roles.find((role) => role.id === roleId);
    setSelectedRole(role);
    auth.setSelectedRole(role);
    //enqueueSnackbar(`Su role cambio a ${role.name} `);
  };

  const detectedOffline = () => {
    //const isOnline = window.navigator.onLine;
    window.onoffline = (event) => {
      const keyLostConection = enqueueSnackbar('Estás sin conexión', {
        variant: 'error',
        persist: true,
      });
      setKeyLostConection(keyLostConection);
    };
  };
  const detectedOnLine = (key) => {
    window.ononline = (event) => {
      closeSnackbar(key);
      enqueueSnackbar('Estás de regreso!', {
        variant: 'success',
      });
    };
  };

  // const { user, roles } = state;

  return (
    <React.Fragment>
      <Loading open={isLoading} />
      {user !== null ? (
        <div
          style={{
            display: 'flex',
          }}
          className='app'
        >
          <NavBar
            user={user}
            roles={roles}
            onLogin={handleLogin}
            onChangeRole={handleChangeRole}
            onLogout={handleLogout}
            selectedRole={selectedRole}
          />

          <Switch>
            {/* <Route path="/login" component={LoginForm} />
                <Route path="/customers" component={Customers} />
              <Route path="/rentals" component={Rentals} /> */}
            <Route path='/home' exact component={Welcome} />
            <Route path='/proyecto/:slug/miembros' exact component={Members} />
            <Route path='/proyecto/:slug' exact component={ProjectMain} />
            <Route path='/proyecto/:id' exact component={ProjectMain} />

            <Route path='/proyectoI/:slug' exact component={projectMainInv} />
            <Route path='/proyectoI/:id' exact component={projectMainInv} />
            <Route
              path='/proyecto/:slug/actividad/:id'
              exact
              component={EditActivityForm}
            />
            <Route
              path='/componente/:comp/requerimiento/:id'
              exact
              component={EditRequirementForm}
            />
            <Route path='/proyectos' exact component={Projects} />

            <Route path='/proyectos/:year/reporte/Estado/' exact component={ReporteEstado} />
            <Route path='/proyectos/:year/reporte/Cobertura/' exact component={ReporteCobertura} />
            <Route path='/proyectos/:year/reporte/Multidisciplinario/' exact component={ReporteMultidisciplinario} />
            <Route path='/proyectos/:year/reporte/Genero/' exact component={ReporteGeneroInvestigadores} />
            <Route path='/proyectos/:year/reporte/Estudiantes/' exact component={ReporteEstudiantes} />
            <Route path='/proyectos/:year/reporte/Programas' exact component={ReporteProgramas} />
            <Route path='/proyectos/:year/reporte/Lineas' exact component={ReporteLineas} />
            
            
            <Route path='/proyectos/:slug/resoluciones' exact component={resolutionMain} />
            <Route path='/proyectos/:slug/resoluciones/dropzone' exact component={DropzoneMain} />
            
            <Route path='/proyectos/:slug/informe1' exact component={informeMain} />
            <Route path='/proyectos/:slug/informe1/dropzone' exact component={dropzoneMainInforme1} />

            <Route path='/proyectos/:slug/informe2' exact component={informe2Main} />
            <Route path='/proyectos/:slug/informe2/dropzone' exact component={dropzoneMainInforme2} />
            
            <Route path='/proyectosI' exact component={ProjectsI} />
            <Route
              path='/grupo/:id/miembros'
              exact
              component={GroupMembersForm}
            />
            <Route path='/grupos-investigacion' component={Groups} />
            <Route path='/grupos-investigacionI' component={GroupsI} />
            <Route path='/grupo/:id' component={GroupForm} />
            <Route path='/grupoI/:id' component={groupFormI} />
            <Route path='/investigadores' component={Researchers} />
            <Route path='/investigador/:id' component={ResearcherForm} />

            <Route path='/reporte/mensual' component={Monthly} />
            <Route path='/reporte/consulta' component={Query} />
            <Route path='/mi/perfil' component={MeProfile} />

            <Route path='/usuario/new' component={UserAddForm} />
            <Route path='/usuario/:id' component={UserUpdateForm} />
            <Route path='/registrar/:id' component={UserAddForm} />

            <Route path='/dependencias' exact component={Dependencies} />
            <Route path='/dependencia/:id' component={DependencyForm} />
            
            <Route path='/lineas' exact component={Lines} />
            <Route path='/lineas/:id' component={LineForm} />
            <Route path='/linea/new' component={LineAddForm} />

            <Route path='/programa/new' component={ProgramAddForm} />
            <Route path='/programas/update' component={ProgramForm} />

            <Route path='/usuarios' exact component={Users} />
            <Route path='/roles' exact component={Roles} />
            <Route path='/role/:id' component={RoleForm} />
            <Route path='/permisos' exact component={Pemissions} />
            <Route path='/permiso/:id' exact component={PemissionForm} />

            <Route path='/logout' component={Logout} />
            <Route path='/not-found' component={NotFound} />
            <Route path='/not-authorized' component={NotAuthorized} />
            <Redirect to='/not-found' />
            <Redirect to='/not-authorized' />
          </Switch>
        </div>
      ) : (
        <LoginScreen onLogin={handleLogin} />
      )}
    </React.Fragment>
  );
};
export default App;
